<script setup>
import { ref, computed, reactive, onMounted } from 'vue';
import { useSertStore } from '@/stores/sertStore';
import { useSettingsStore } from '@/stores/settingsStore';
import { getListPrices } from '@/utils/services';
import SertHeader from '@/components/blocks/SertHeader.vue';
import BaseSelect from '@/components/ui/BaseSelect.vue';
import BaseBtnLookSert from '../ui/BaseBtnLookSert.vue';

const storeSert = useSertStore();
const storeSettings = useSettingsStore()

const selectOptions = ref([]);

const nextSreen = async () => {   
    storeSert.goToScreen(storeSert.screens.checked)
    history.pushState(null, "", `#${storeSert.screens.checked}`)       
};

const previousSreen = () => {
    storeSert.goToScreen(storeSert.screens.recipient)
    history.pushState(null, "", `#${storeSert.screens.recipient}`)
}

const formatted = new Intl.NumberFormat('ru-RU').format(storeSettings.settings.min_certificate_denomination_for_physical);

onMounted( async () => {
    selectOptions.value = await getListPrices()
})
</script>
<template>
    <div class="constructor">
        <div class="constructor__body">
            <SertHeader :white-steps="6">
                <template #title>Выберите сумму сертификата</template>
                <template #text>Укажите номинал</template>
            </SertHeader>            
            <div class="form">
                <div class="form__row">
                    <BaseSelect :select-options></BaseSelect>
                </div>
            </div>
        </div>
        <div class="constructor__btns-inner">
            <div class="constructor__btns">
                <button class="btn --black" @click="previousSreen">
                    <span>Назад</span>
                </button>
                <button :disabled="storeSert.isBtnDisabled(['select'])" class="btn --full" @click="nextSreen">
                    <span>Далее</span>
                </button>
                <BaseBtnLookSert/>
            </div>
        </div>
    </div>
</template>
<style lang='scss' scoped>
@use '@/assets/scss/base/vars';
</style>